function getThemingProperty(element, variablesObj) {
  let computedStyles = getComputedStyle(element);
  function getColorTemplates(computedStyles, variables, variablesObj) {
    return variables.map((variable) => {
      let colorCode = computedStyles.getPropertyValue(variable);
      if (colorCode) {
        return colorCode;
      } else {
        return variablesObj[variable];
      }
    });
  }

  function getFontProperty(computedStyles, variablesObj) {
    const variable = "--kf-font-family";
    let fontProperty = computedStyles.getPropertyValue(variable);
    if (fontProperty) {
      return fontProperty;
    } else {
      return variablesObj[variable];
    }
  }

  return {
    normalColors: getColorTemplates(
      computedStyles,
      Object.keys(variablesObj.normal),
      variablesObj.normal
    ),
    brightenColors: getColorTemplates(
      computedStyles,
      Object.keys(variablesObj.brighten),
      variablesObj.brighten
    ),
    fontProperty: {
      fontFamily: getFontProperty(computedStyles, variablesObj.font)
    }
  };
}

export { getThemingProperty };
